var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/_Uint8Array.js
// module id = 498
// module chunks = 30 31 32 33